import React, { useState } from 'react'
import { StyleSheet, View, Text, ScrollView } from 'react-native'
import { Button, Title, Description, Space, HorizontalLine, MenuList } from '@sart/components'
import { useContent } from '@sart/content'
import { Linking } from 'react-native'

import * as theme from './Sign/signTheme'
import { SafeAreaView } from 'react-native-safe-area-context'

import { adaptive, backgroundColors, colors, typography } from '@sart/styles'

import AppConfig from './Configuration'

export default function Confirmation(props) {
  const { navigation } = props

  const [activeSections, setActiveSections] = useState([])
  const content = useContent()

  const sections = [
    // {id: 'Usage', label: 'Usage' },
    { id: 'callCenter', label: content.help.contactCallCenterTitle },
    { id: 'whatsApp', label: content.help.contactWhatsAppTitle },
    { id: 'aboutUs', label: content.help.learnAboutUs },
  ]

  function handleNavigation(section) {
    if (section.id === 'callCenter') {
      Linking.openURL(`tel:${AppConfig.callCenterNumber}`)
    } else if (section.id === 'whatsApp') {
      Linking.openURL(`https://wa.me/${AppConfig.whatsAppNumber}`)
    } else if (section.id === 'aboutUs') {
      setActiveSections(!activeSections)
    }
  }
  return (
    <SafeAreaView style={styles.container}>
      <ScrollView>
        <View style={styles.wrapper}>
          <Space height={24} />
          <Space height={32} />
          <Title style={styles.title}>{content.help.title}</Title>
          <Space height={16} />
          <MenuList color={colors.white}>
            {
              sections.map(section =>
                <MenuList.Item
                  key={section.id}
                  label={section.label}
                  onPress={() => handleNavigation(section)}
                  style={styles.menuListItemStyle}
                />
              )
            }
          </MenuList>
          {!activeSections &&
            <Description style={styles.description}>
              {content.help.learnAboutUsDescription}
            </Description>
          }
          <Description style={styles.link} onPress={() => Linking.openURL("https://exis.mx/#/about")}>
            {content.help.visitWebsite}
          </Description>
          <Button
            title={content.common.back}
            onPress={() => navigation.navigate('Sign', { screen: 'SignIn' })}
            style={styles.button}
            titleStyle={{ ...typography.demi, fontSize: 18, color: colors.srGreen }}
          />
        </View>
      </ScrollView>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: backgroundColors.srGreen,
    ...adaptive.wrapperPadding
  },
  wrapper: {
    flex: 1
  },
  title: {
    color: colors.white,
    ...typography.extrabold,
    fontSize: 22
  },
  description: {
    paddingTop: 5,
    textAlign: 'center',
    ...typography.demi,
    color: colors.black
  },
  link: {
    paddingTop: 5,
    textAlign: 'center',
    ...typography.demi,
    color: colors.white
  },
  button: {
    backgroundColor: colors.srGreyBackground,
  },
  menuListItemStyle: {
    fontSize: 16,
    ...typography.lightbold,
    color: colors.black
  },
})
